import { SETTINGS_STORAGE_KEY, defaultSettings } from './appSettings.js'

export function loadStoredSettings() {
  try {
    const storedSettings = JSON.parse(localStorage.getItem(SETTINGS_STORAGE_KEY))
    return mergeWithDefaults(storedSettings)
  } catch {
    return mergeWithDefaults()
  }
}

export function saveSettingsSnapshot(snapshot) {
  localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(snapshot))
}

export function createSettingsSnapshot({
  effectParams,
  cameraParams,
  orbitSettings,
  fishEyeParams,
  spiralParams,
  utilityParams,
  guiFolderParams
}) {
  return {
    effect: {
      enabled: effectParams.enabled,
      family: effectParams.family,
      effect: effectParams.effect,
      intensity: effectParams.intensity,
      speed: effectParams.speed,
      autoReplay: effectParams.autoReplay,
      replayDuration: effectParams.replayDuration,
      pause: effectParams.pause
    },
    camera: {
      autoRotate: cameraParams.autoRotate,
      autoRotateSpeed: cameraParams.autoRotateSpeed,
      orbit: orbitSettings
    },
    fishEye: { ...fishEyeParams },
    spiral: { ...spiralParams },
    utility: { ...utilityParams },
    gui: { folders: { ...guiFolderParams } }
  }
}

function mergeWithDefaults(storedSettings = {}) {
  return {
    effect: { ...defaultSettings.effect, ...storedSettings?.effect },
    camera: { ...defaultSettings.camera, ...storedSettings?.camera },
    fishEye: { ...defaultSettings.fishEye, ...storedSettings?.fishEye },
    spiral: { ...defaultSettings.spiral, ...storedSettings?.spiral },
    utility: { ...defaultSettings.utility, ...storedSettings?.utility },
    gui: {
      folders: {
        ...defaultSettings.gui.folders,
        ...storedSettings?.gui?.folders
      }
    }
  }
}
